<template>
  <v-container fluid>
    <v-card>
      <v-progress-linear
        :active="isLoading"
        :indeterminate="isLoading"
        absolute
        top
        color="secondary"
      >
      </v-progress-linear>
      <v-toolbar flat rounded>
        <v-toolbar-title>Clients</v-toolbar-title>
        <v-spacer></v-spacer>
        <base-search-bar v-model="search" background-color=""></base-search-bar>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="reload"
              ><base-icon name="sync-alt" :spin="isLoading"></base-icon>
            </v-btn>
          </template>
          <span>Sync</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              fab
              small
              elevation="3"
              class="ml-2"
              v-bind="attrs"
              v-on="on"
              @click="onAdd({})"
              ><base-icon name="plus"></base-icon>
            </v-btn>
          </template>
          <span>Add</span>
        </v-tooltip>
      </v-toolbar>
      <v-divider></v-divider>
      <v-data-table :headers="headers" :items="clients" :search="search">
        <template v-slot:[`item.actions`]="{ item }">
          <div class="text-no-wrap">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" icon v-on="on" @click="onEdit(item)">
                  <base-icon name="edit"></base-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" icon :disabled="!hasScope(scopeTypes.clientsDelete)" v-on="on" @click="onDelete(item)" >
                  <base-icon name="trash"></base-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <client ref="editor" :clients="clients" @refresh="load"></client>
  </v-container>
</template>

<script>
import Client from '@components/manager-client.vue'
import { scopeType } from '@constants/scope-type'
import { mapGetters } from 'vuex'

export default {
  components: {
    Client,
  },
  data: () => ({
    isLoading: false,
    search: '',
    query: '',
    headers: [
      { text: 'Name', value: 'Name' },
      { text: 'Description', value: 'Description' },
      {
        text: 'ClientId',
        value: 'ClientId',
      },
      {
        text: 'Actions',
        value: 'actions',
        sortable: false,
        align: 'center',
        class: 'w-0',
      },
    ],
    clients: [],
    scopeTypes: scopeType,
  }),
  computed: {
    ...mapGetters('user', ['hasScope']),
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.isLoading = true
      return this.$store
        .dispatch('client/get')
        .then(
          (result) => {
            this.clients = result.map((x) => {
              if (!x.Description) x.Description = '--'
              return x
            })
          },
          (error) => {
            console.error(error)

            this.$store.dispatch('messaging/errorNotification', {
              errorCode: error.errorCode,
              unhandledMessage:
                'An unexpected error occurred while retrieving data. Please try again later.',
            })
          }
        )
        .finally(() => {
          this.isLoading = false
        })
    },
    reload() {
      this.load().then(
        () => {
          this.$store.dispatch('messaging/notify', {
            type: 'success',
            message: 'Successfully reloaded clients',
            duration: 2000,
          })
        },
        () => {}
      )
    },
    onAdd(item) {
      this.onEdit(item)
    },
    onEdit(item) {
      this.$refs.editor.open(item)
    },
    onDelete(item) {
      this.$store
        .dispatch('messaging/confirm', {
          title: 'Confirm Delete',
          message: `You are about to delete: <span class="error--text font-weight-medium">${item.Name} - ${item.ClientId}</span>. Are you sure?`,
          actions: [
            {
              label: 'Cancel',
              result: 'canceled',
              textBtn: true,
              closeOnClick: true,
            },
            {
              label: 'Yes, Delete',
              result: 'confirmed',
              color: 'error',
              loadingInd: true,
            },
          ],
        })
        .then((result) => {
          if (result === 'confirmed') {
            this.isLoading = true
            this.$store
              .dispatch('client/remove', item.ClientId)
              .then(
                () => {
                  this.load()

                  this.$store.dispatch('messaging/closeConfirm')

                  this.$store.dispatch('messaging/notify', {
                    type: 'success',
                    message: 'Successfully removed client',
                    duration: 2000,
                  })
                },
                (error) => {
                  console.error(error)
                  this.$store.dispatch('messaging/errorNotification', {
                    errorCode: error.errorCode,
                    unhandledMessage:
                      'An unexpected error occurred while removing client. Please try again later.',
                  })
                }
              )
              .finally(() => {
                this.isLoading = false
              })
          }
        })
    },
  },
}
</script>
